import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TokenService } from '../services/token.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const translateService = inject(TranslateService);

  const currentLang =
    translateService.getCurrentLang() || translateService.getFallbackLang()!;

  const headers: Record<string, string> = {
    'X-Locale': currentLang,
    'X-Client-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'X-Locale-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'X-Client-Locale': currentLang,
    'ngrok-skip-browser-warning': 'true',
  };

  const token = tokenService.getToken();

  if (token) {
    if (!tokenService.isAuthenticated()) {
      tokenService.clearToken();
      if (!req.url.includes('/login')) {
        router.navigate(['/auth/login']);
      }
    } else {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  const cloned = req.clone({
    setHeaders: headers,
  });

  return next(cloned);
};
